import { ThumbsUpDownIcon } from './ThumbsUpDownIcon';

/**
 * author: Google
 * id C38D6CEC-4D8E-44DB-B704-9A76552733D4
 * name thumbs-up-down
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thumbs-up-down.svg
 * tags
 */
export const LikeDislikeIcon = ThumbsUpDownIcon;
export default LikeDislikeIcon